import {Wordland} from "./core/Wordland";
import {DebugProvider} from "./debug/DebugProvider";
import {ErrorBoundary} from "@sentry/react";
import {ErrorFallback} from "./debug/ErrorFallback";
import {HostProvider} from "./host/HostProvider";
import {GameProvider} from "@components/game/GameProvider";
import {AdProvider} from "../AdProvider";

export function App() {
    return (
        <ErrorBoundary fallback={ErrorFallback}>
            <AdProvider>
                <HostProvider>
                    <GameProvider>
                        <DebugProvider>
                            <Wordland/>
                        </DebugProvider>
                    </GameProvider>
                </HostProvider>
            </AdProvider>
        </ErrorBoundary>
    );
}